import { getResourceDefinition, IResourceValueRecord } from './definitions'

type ResourceUnknownRecord = Record<string, unknown>

interface IResolveResourceValueArgs {
  record: IResourceValueRecord
  resourceTypeId?: string
  key: string
}

const hasOwn = (
  target: ResourceUnknownRecord | null | undefined,
  key: string,
) => !!target && Object.prototype.hasOwnProperty.call(target, key)

const getByPath = (
  target: ResourceUnknownRecord | null | undefined,
  path: string,
): unknown =>
  path.split('.').reduce<unknown>((acc, segment) => {
    if (acc == null || typeof acc !== 'object') {
      return undefined
    }
    return (acc as ResourceUnknownRecord)[segment]
  }, target)

export const resolveResourceValue = ({
  record,
  resourceTypeId,
  key,
}: IResolveResourceValueArgs): unknown => {
  if (!record || !key) {
    return undefined
  }

  const definition = getResourceDefinition(resourceTypeId)
  const sourceDefinition = definition?.valueSources?.[key]

  const data = record.data || {}
  if (!sourceDefinition && hasOwn(data, key)) {
    return data[key]
  }

  if (!sourceDefinition) {
    return data[key]
  }

  if (sourceDefinition.resolve) {
    return sourceDefinition.resolve(record)
  }

  if (sourceDefinition.source === 'data') {
    if (sourceDefinition.path) {
      return getByPath(data, sourceDefinition.path)
    }

    return data[key]
  }

  const root = record.root || (record as ResourceUnknownRecord)

  if (sourceDefinition.path) {
    return getByPath(root, sourceDefinition.path)
  }

  return root[key]
}
